import MainSideBar from '@/components/Sidebar/main-sidebar';
import SettingsDrilldown from '@/components/Sidebar/settings-drilldown';

type SidebarNavigationProps = {
  currentView: 'MAIN' | 'SETTINGS';
  setCurrentView: (view: 'MAIN' | 'SETTINGS') => void;
  isCollapsed: boolean;
  menuItems: MenuItem[];
  isActive: (route?: string) => boolean;
  isMobile: boolean;
  setOpenMobile: (open: boolean) => void;
};

export default function SidebarNavigation({
  currentView,
  setCurrentView,
  isCollapsed,
  menuItems,
  isActive,
  isMobile,
  setOpenMobile,
}: SidebarNavigationProps) {
  return (
    <div className="relative h-full min-h-0">
      <div
        className={`absolute inset-0 transition-[transform,opacity] duration-300 ease-out ${
          currentView === 'SETTINGS'
            ? 'pointer-events-none translate-x-[1.6rem] opacity-0'
            : 'translate-x-0 opacity-100'
        }`}
      >
        <MainSideBar
          isCollapsed={isCollapsed}
          menuItems={menuItems}
          isActive={isActive}
          setCurrentView={setCurrentView}
          isMobile={isMobile}
          setOpenMobile={setOpenMobile}
        />
      </div>
      <SettingsDrilldown
        open={currentView === 'SETTINGS'}
        onBack={() => setCurrentView('MAIN')}
        isCollapsed={isCollapsed}
        onNavigate={() => {
          if (isMobile) setOpenMobile(false);
        }}
        isActive={isActive}
      />
    </div>
  );
}
